import {
  CommentForum,
} from '../implementations';

const mappers = {
  comment_forum: CommentForum,
};

export default mappers;
